document.documentElement.classList.replace('no-js', 'js');
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-dialog-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.dialogOpen);
    if (dialog && !dialog.open) { dialog.showModal(); document.body.style.overflow = 'hidden'; }
  }
  const closer = event.target.closest('[data-dialog-close]');
  if (closer) closer.closest('dialog')?.close();
  if (event.target.matches('dialog')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
  if (event.target.closest('dialog a[href]')) event.target.closest('dialog').close();
});
document.addEventListener('close', (event) => {
  if (event.target.matches('dialog')) document.body.style.overflow = '';
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown[open]').forEach(el => el.removeAttribute('open'));
});
